import React, { useEffect, useState } from 'react';
import ScrollReveal from 'scrollreveal';
import '../index.css'
import img1 from '../assets/portfolio.png'
import img2 from '../assets/design.png'
import img3 from '../assets/coding.png'
import img4 from '../assets/ui-ux.png'
import img5 from '../assets/project.jpg'
// import img6 from '../assets/image1.jpg'
import prof1 from '../assets/profile1.jpg'
import prof2 from '../assets/profile2.jpg'
import prof3 from '../assets/profile3.jpg'
import img7 from '../assets/typing.png'
import img8 from '../assets/vlogger.png'
import img9 from '../assets/data.png'
import img10 from '../assets/milk.png'
import { BsArrowDownRight, BsCheck, BsStarFill } from 'react-icons/bs';
import {  ReactTyped} from 'react-typed';
import CountUp from 'react-countup';
// import Slider from 'react-slick';

function Home () {
  const [activeClient, setActiveClient] = useState<number>(0) // Specify type as number

  useEffect(() => {
    const sr = ScrollReveal({
      origin: 'bottom',
      distance: '50px',
      duration: 2000,
      delay: 200,
      reset: false,
    });

    sr.reveal('.hero-img', { delay: 500, origin: 'right', });
    sr.reveal('.mybtn1', { delay: 600 });
    sr.reveal('.top', { delay: 600, origin: 'left', });
    // sr.reveal('.projects', { delay: 700 });
    // sr.reveal('.skills', { delay: 800 });
    // sr.reveal('.clients', { delay: 900 });
  }, []);

  const clientsData = [
    {
      img: prof1,
      description:
        'Purity has been instrumental in transforming our online presence. Her keen eye for design and understanding of user experience have greatly enhanced our website’s usability and aesthetics. We couldn’t be happier with the results!',
      name: 'John Doe',
      title: 'CEO & Founder'
    },
    {
      img: prof2,
      description:
        'Working with Purity was a game-changer for our mobile app development. Her expertise and innovative approach ensured that our app was both functional and visually appealing. She is a true professional!',
      name: 'Kianna Vetravs',
      title: 'Mobile Developer'
    },
    {
      img: prof3,
      description:
        'Purity’s graphic design skills are top-notch. She took our ideas and turned them into stunning visuals that perfectly represent our brand. Her creativity and attention to detail are unmatched.' ,
      name: 'Irungu Ryan',
      title: 'Graphic Designer'
    }
  ]

  const handleDotClick = (index: number) => {
    // Specify type as number
    setActiveClient(index)
  }
  return (
    <div className='w-full'>
      <div className='hero flex flex-col justify-center items-center pb-8 mx-10 bg-[#0c141d]'>
        <div className='w-full flex flex-col md:flex-row justify-center items-start gap-12 md:gap-36 mt-48 ml-10 md:ml-0'>
          <div className='flex flex-col justify-start items-start gap-4 text-white'>
            <h2 className='text-[#5B62FB] text-sm capitalize'>hello, i'm purity irungu</h2>
            <h2 className=''>I am a &nbsp; 
              <ReactTyped className='text-[#5B62FB]'
                strings={[
                  'Web Developer',
                  'UI/UX Designer',
                  'Data Entry Clerk',
                  'Blogger',
                ]}
                typeSpeed={50}
                backSpeed={50}
                loop
              />
            </h2>
            <p className='para w-96'>
              With a keen eye for design and a passion for coding, I specialize
              in creating visually appealing and highly functional websites. My
              goal is to deliver seamless user experiences and cutting-edge web
              solutions that help businesses stand out in the digital world.
              Whether you're looking for a brand-new website or a redesign, I'm
              here to bring your vision to life.
            </p>
            <div className='flex flex-row'>
              <button className='mybtn1'>Hire Me</button>
            </div>
          </div>
          <div className=''>
            <img src={img1} alt='' className='hero-img' />
          </div>
        </div>
        <div className='grad flex flex-row justify-between items-center text-white w-3/4 p-6'>
          <AboutMe num='3+' name='Years of experience' />
          <AboutMe num='5+' name='Clients' />
          <AboutMe num='100+' name='Completed projects' />
          <AboutMe num='7+' name='Appointments' />
        </div>
      </div>
      <div className='serv w-fit flex flex-col gap-8 py-10 px-24 my-20 mx-10 bg-[#0c141d]'>
        <div className='top flex flex-row gap-4 items-center'>
          <div className='rounded-full bg-[#070a0e] p-[2px]'>
            <div className='circle p-3'>
              <BsArrowDownRight className='text-white' />
            </div>
          </div>
          <h2 className='items-start text-start text-xl text-white'>
            SERVICES 🤑
          </h2>
        </div>
        <div className='serv-bx w-fit flex flex-row justify-center items-center flex-wrap gap-8'>
          <Services
            image={img2}
            name='Designer'
            text='Crafting visually stunning and user-friendly designs that captivate and engage audiences.'
          />
          <Services
            image={img3}
            name='Developer'
            text='Building robust, scalable, responsive, and efficient web applications tailored to your needs.'
          />
          <Services
            image={img4}
            name='UI/UX'
            text='Designing intuitive and seamless user experiences that enhance user satisfaction.'
          />
          <Services
            image={img8}
            name='Blogger'
            text='Creating insightful and engaging content that drives traffic and boosts brand presence.'
          />
          <Services
            image={img7}
            name='Typing'
            text='Providing fast and accurate typing services for all your data entry and transcription needs.'
          />
          <Services
            image={img9}
            name='Data Specialist'
            text='Analyzing and managing data to provide actionable insights and drive informed decision-making.'
          />
        </div>
      </div>
      <div className='projects flex flex-col gap-14 py-10 px-24 mx-10 my-20 bg-[#0c141d]'>  
        <div className='top flex flex-row gap-4 items-center'>
          <div className='rounded-full bg-[#070a0e] p-[2px]'>
            <div className='circle p-3'>
              <BsArrowDownRight className='text-white' />
            </div>
          </div>
          <h2 className='items-start text-start text-xl text-white'>
            FEATURED PROJECTS 🚧
          </h2>
        </div>
        <div className='flex flex-col gap-28'>
          <div className='flex flex-col md:flex-row justify-between items-start gap-10 text-white'>
            <div className='proj flex flex-col gap-5 w-full ml-28'>
              <h1>Personal Project</h1>
              <h2 className='text-xl'>Milk Record Management System</h2>
              <div className='flex flex-col gap-4'>
                <div className='flex flex-row items-center gap-4'>
                  <div className='circles'>
                    <BsCheck />
                  </div>
                  <p>Clean and Creative UI</p>
                </div>
                <div className='flex flex-row items-center gap-4'>
                  <div className='circles'>
                    <BsCheck />
                  </div>
                  <p>Easy to change color style</p>
                </div>
                <div className='flex flex-row items-center gap-4'>
                  <div className='circles'>
                    <BsCheck />
                  </div>
                  <p>Well organized layers</p>
                </div>
              </div>
            </div>
            <div className='w-full'>
              <img src={img10} alt='' className='img' />
            </div>
          </div>
          <div className='reverse flex flex-col md:flex-row justify-around gap-10 text-white'>
            <div className='w-full ml-0 md:ml-28'>
              <img src={img5} alt='' className='img' />
            </div>
            <div className='proj flex flex-col gap-5 w-full ml-28'>
              <h1>Personal Project</h1>
              <h2 className='text-xl'>Milk Record Management System</h2>
              <div className='flex flex-col gap-4'>
                <div className='flex flex-row items-center gap-4'>
                  <div className='circles'>
                    <BsCheck />
                  </div>
                  <p>Clean and Creative UI</p>
                </div>
                <div className='flex flex-row items-center gap-4'>
                  <div className='circles'>
                    <BsCheck />
                  </div>
                  <p>Easy to change color style</p>
                </div>
                <div className='flex flex-row items-center gap-4'>
                  <div className='circles'>
                    <BsCheck />
                  </div>
                  <p>Well organized layers</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='skills w-fit flex flex-col gap-14 py-10 px-24 mx-10 my-20 bg-[#0c141d]'>
        <div className='top flex flex-row gap-4 items-center'>
          <div className='rounded-full bg-[#070a0e] p-[2px]'>
            <div className='circle p-3'>
              <BsArrowDownRight className='text-white' />
            </div>
          </div>
          <h2 className='items-start text-start text-xl text-white'>
            MY SKILLS 👩🏻‍💻
          </h2>
        </div>
        <div className='skill-bx flex flex-row gap-12 flex-wrap'>
          <div className='flex flex-col gap-1 text-white'>
            <div className='flex flex-row justify-between'>
              <h2>HTML5</h2>
              <h2>90%</h2>
            </div>
            <div className='w-[350px] md:w-[500px] h-2 bg-slate-700'>
              <div className='left-0 top-0 h-full w-[90%] bg-[#1F59AB]'></div>
            </div>
          </div>
          <div className='flex flex-col gap-1 text-white'>
            <div className='flex flex-row justify-between'>
              <h2>CSS</h2>
              <h2>90%</h2>
            </div>
            <div className='w-[350px] md:w-[500px] h-2 bg-slate-700'>
              <div className='left-0 top-0 h-full w-[90%] bg-[#1F59AB]'></div>
            </div>
          </div>
          <div className='flex flex-col gap-1 text-white'>
            <div className='flex flex-row justify-between'>
              <h2>JavaScript</h2>
              <h2>40%</h2>
            </div>
            <div className='w-[350px] md:w-[500px] h-2 bg-slate-700'>
              <div className='left-0 top-0 h-full w-[40%] bg-[#1F59AB]'></div>
            </div>
          </div>
          <div className='flex flex-col gap-1 text-white'>
            <div className='flex flex-row justify-between'>
              <h2>PHP</h2>
              <h2>50%</h2>
            </div>
            <div className='w-[350px] md:w-[500px] h-2 bg-slate-700'>
              <div className='left-0 top-0 h-full w-[50%] bg-[#1F59AB]'></div>
            </div>
          </div>
          <div className='flex flex-col gap-1 text-white'>
            <div className='flex flex-row justify-between'>
              <h2>React</h2>
              <h2>40%</h2>
            </div>
            <div className='w-[350px] md:w-[500px] h-2 bg-slate-700'>
              <div className='left-0 top-0 h-full w-[40%] bg-[#1F59AB]'></div>
            </div>
          </div>
          <div className='flex flex-col gap-1 text-white'>
            <div className='flex flex-row justify-between'>
              <h2>SQL</h2>
              <h2>60%</h2>
            </div>
            <div className='w-[350px] md:w-[500px] h-2 bg-slate-700'>
              <div className='left-0 top-0 h-full w-[60%] bg-[#1F59AB]'></div>
            </div>
          </div>
          <div className='flex flex-col gap-1 text-white'>
            <div className='flex flex-row justify-between'>
              <h2>Tailwind CSS</h2>
              <h2>50%</h2>
            </div>
            <div className='w-[350px] md:w-[500px] h-2 bg-slate-700'>
              <div className='left-0 top-0 h-full w-[50%] bg-[#1F59AB]'></div>
            </div>
          </div>
          <div className='flex flex-col gap-1 text-white'>
            <div className='flex flex-row justify-between'>
              <h2>Typescript</h2>
              <h2>20%</h2>
            </div>
            <div className='w-[350px] md:w-[500px] h-2 bg-slate-700'>
              <div className='left-0 top-0 h-full w-[20%] bg-[#1F59AB]'></div>
            </div>
          </div>
        </div>
      </div>
      <div className='clients flex flex-col gap-24 py-10 px-24 mx-10 my-20 bg-[#0c141d]'>
        <div className='top flex flex-row gap-4 items-center'>
          <div className='rounded-full bg-[#070a0e] p-[2px]'>
            <div className='circle p-3'>
              <BsArrowDownRight className='text-white' />
            </div>
          </div>
          <h2 className='items-start text-start text-xl text-white'>
            LISTEN TO OUR CLIENTS 👦
          </h2>
        </div>
        <div className='flex flex-col md:flex-row gap-24 md:gap-8 text-white'>
          {clientsData.map((client, index) => (
            <div
              key={index}
              className={`clients relative flex flex-col justify-center items-center md:lg:hover:border-white md:lg:hover:opacity-65 p-6 gap-4 ${
                activeClient === index ? 'scale-110' : ''
              }`}
            >
              <img
                src={client.img}
                alt=''
                className='rounded-full absolute -top-10'
              />
              <p className='w-72 text-center text-sm tracking-widest pt-6'>{client.description}</p>
              <div className='flex flex-row gap-1 text-yellow-500'>
                <BsStarFill className='text-sm'/>
                <BsStarFill className='text-sm'/>
                <BsStarFill className='text-sm'/>
                <BsStarFill className='text-sm'/>
                <BsStarFill className='text-sm'/>
              </div>
              <div className='w-full h-[.3px] mt-10 opacity-15 bg-slate-300'></div>
              <h2>{client.name}</h2>
              <h2>{client.title}</h2>
            </div>
          ))}
        </div>
        <div className='flex justify-center items-center mt-6'>
          {clientsData.map((_, index) => (
            <div
              key={index}
              onClick={() => handleDotClick(index)}
              className={`w-3 h-3 rounded-full cursor-pointer ${
                activeClient === index ? 'bg-blue-500' : 'bg-gray-500'
              }`}
            ></div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Home

function AboutMe(props: { num: string; name: string }) {
  const num = parseInt(props.num.replace('+', ''), 10);
  return (
    <div className='about flex flex-col gap-1'>
      <h2 className='font-bold'>
        <CountUp
          start={0}
          end={num}
          duration={10} // Adjust the duration as needed
          delay={0.8} // Add a slight delay before starting
          suffix='+'
        />
      </h2>
      <h4 className='text-sm'>{props.name}</h4>
    </div>
  )
}

function Services (props: any) {
  return (
    <div className='services'>
      <div className='service-cont flex flex-col items-center gap-4 px-1 py-3 m-3'>
        <img src={props.image} alt='' className='w-16' />
        <h2 className='service-name'>{props.name}</h2>
        <p className='w-72 text-white text-center'>{props.text}</p>
        <button className='service-btn'>Learn More</button>
      </div>
    </div>
  )
}
